import React, { useEffect, useState } from 'react'
import useWindowSize from '../../hooks/useWindowSize';
import Modal from '../../ReusableComponents/Modal';
import Form from '../../ReusableComponents/Form';
import { emailValidation, nameValidation, passwordValidation, selectFieldValidation } from '../../utils/inputValidations';
import InputField from '../../ReusableComponents/InputField';
import { Button } from '../../Components/Helper';
import { BHUMEET_TEAM_ROLES, INDIAN_STATES } from '../../appConstants';
import SelectField from '../../ReusableComponents/SelectField';
import { addTeamMember, updateTeamMember } from '../../apis/adminAPIs/teams';
import Loading from '../../ReusableFunctions/Loader';
import Popup from '../../ReusableFunctions/Popup';
import Tippy from '@tippyjs/react';
import { reShuffleRequestQueue } from '../../apis/BhuMeetTeams/Telecaller/requestqueue';
import { getAllDSPs } from '../../apis/adminAPIs/dsp';
import { Select } from '@mui/material';
import { GLOBAL_STYLES } from '../../appConstants';
import MultiSelectField from '../../ReusableComponents/MultiSelectField';
import { id } from 'date-fns/locale';

export default function AddTeamMember({
    open,
    onClose,
    onOperatorAdd,
    operator
}) {

    const defaultStyles = {
        control: (provided, state) => ({
            ...provided,
            fontSize: "12px",
            background: "#F3F3F3",
            borderRadius: "5px",
            borderColor: GLOBAL_STYLES.BORDER_COLOR,
            outline: "none",
            fontWeight: 600,
            color: "black",
            // height: "35px",
        }),
        option: (provided, state) => ({
            ...provided,
            fontSize: "12px",
            boxShdow: GLOBAL_STYLES.BOX_SHADOW,
            color: state.isFocused && !state.isSelected ? "black" : state.isSelected ? "white" : state.isSelected && state.isFocused ? "white" : "black",
            backgroundColor: state.isFocused && !state.isSelected ? "rgba(0, 0, 0, 0.1)" : state.isSelected ? GLOBAL_STYLES.BG_ACTIVE : GLOBAL_STYLES.BG_INACTIVE,
            minHeight: "35px",
        }),
        valueContainer: (provided, state) => ({
            ...provided,
        }),
        menu: (provided, state) => ({
            ...provided,
        }),
        menuList: (provided, state) => ({
            ...provided,
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
        }),
        indicatorContainer: (provided, state) => ({
            ...provided,
        }),
        dropdownIndicator: (provided, state) => ({
            ...provided,
        }),
        singleValue: (provided, state) => ({
            ...provided,
        }),
        loadingIndicator: (provided, state) => ({
            ...provided,
            color: "#a1bffd",
            fontSize: "5px",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 })
    };
    // console.log(operator)

    const [operatorInfo, setOperatorInfo] = useState(operator?.id ?
        {
            ...operator,
            bhumeet_role: { label: operator.bhumeet_role, value: operator.bhumeet_role },
            assignStatus: operator.assigneStatus,
            MobileNumber: operator.phone || '',
            Dsp: operator.tele_dsp_exclude_queue.map(x => {
                return { label: x.name, value: x.id, excludeStatus: x.excludeStatus, id: x.dspID }
            }) ?? [],
            State: operator.State ? operator.State.map(state => ({ label: state, value: state }))
                : null ?? ""

        }
        : {
            name: "",
            email: "",
            password: "",
            bhumeet_role: "",
            assignStatus: [],
            MobileNumber: "",
            Dsp: [],
            State: []
        });
    const [dsplist, setDspList] = useState([])
    const { currentHeight, currentWidth } = useWindowSize();
    const teamRolesOptions = Object.values(BHUMEET_TEAM_ROLES).map(role => ({
        label: role.NAME,
        value: role.NAME,
    }));

    const getAllDspName = async () => {
        getAllDSPs().then(res => {
            // console.log(res)
            let dspOptions = res.dsps.map(dsp => {

                if (dsp.dsp_is_active) {
                    return ({
                        label: dsp.dsp_name,
                        value: dsp.dsp_id,
                    })
                }
            }).filter(Boolean);
            console.log(dspOptions)
            setDspList(dspOptions)
        })
    }
    useEffect(() => {
        console.log(operatorInfo)
    }, [operatorInfo])

    useEffect(() => {
        getAllDspName()
    }, [])

    const handleOnChangeDsp = (e, dspName) => {
        const value = e.target.value;
        const isChecked = e.target.checked;
        // console.log(isChecked)
        let dsps = operatorInfo.Dsp
        let getdps = dsps.map(dsp => {
            if (dsp.label == dspName) {
                dsp.excludeStatus = dsp.excludeStatus ?? []
                if (isChecked) {
                    dsp.excludeStatus = [...dsp.excludeStatus, value]
                } else {
                    dsp.excludeStatus = dsp.excludeStatus.filter(assign => assign !== value)
                }
                dsp.excludeStatus = Array.from(new Set(dsp.excludeStatus))
            }
        })

        if (isChecked) {
            // console.log(dsps)
            // dsps = [...dsps, value]
            setOperatorInfo(prev => ({ ...prev, Dsp: dsps }))
        } else {
            // console.log(dsps)
            setOperatorInfo(prev => ({ ...prev, Dsp: dsps }))

        }

    };


    const handleOnChangeAssignee = (e) => {

        const value = e.target.value
        // console.log(value)
        let assignee = operatorInfo.assignStatus ?? []
        if (e.target.checked) {
            assignee = [...assignee, value]
        } else {
            assignee = assignee.filter(dsp => dsp !== value)
        }
        assignee = Array.from(new Set(assignee))
        setOperatorInfo(prev => ({ ...prev, assignStatus: assignee }))
    }

    const teleSubvalue = ['Accepted', 'Completed', 'Paid', 'Placed', 'Out for Service', 'InProgress', 'Cancelled', 'On Hold']


    const addTeamMemberFunc = async (operator) => {
        Loading.set(true);
        try {
            const addedMember = await addTeamMember(operator);
            if (operatorInfo.bhumeet_role.label == 'Telecaller') {
                // const reshuffled = await reShuffleRequestQueue()

                Popup.alert("SUCCESS", "Successfully Reshuffled Request And Team Member Added", "SUCCESS")
            } else {
                Popup.alert("Team Member", "Team member added successfully", "SUCCESS")
            }

            onOperatorAdd(addedMember)
            Loading.set(false);
        } catch (err) {
            Loading.set(false);
            Popup.alert("Error", err, 'ERROR')
        }
    }

    const updateTeamMemberFunc = async (operator) => {
        Loading.set(true);
        try {
            const updatedOperator = await updateTeamMember(operator?.id, operator);
            Popup.alert("Team Member", "Team member updated successfully", "SUCCESS")
            onOperatorAdd(updatedOperator)
            Loading.set(false);
        } catch (err) {
            Loading.set(false);
            Popup.alert("Error", err, 'ERROR')
        }
    }
    return (
        <Modal
            header={operator ? "Edit Team Member" : "Add Team Member"}
            open={open}
            onClose={onClose}
            contentStyle={{ width: "747px", height: "auto", borderRadius: "10px" }}
            headerContainerStyle={{ padding: currentHeight < 661 ? "15px 30px" : "25px 30px", }}
        >
            <Form
                onSubmitForm={(operatorDetails) => {
                    const operatorInfo = {
                        ...operatorDetails,
                        bhumeet_role: operatorDetails?.bhumeet_role?.value
                    }
                    operator?.id ? updateTeamMemberFunc(operatorInfo) : addTeamMemberFunc(operatorInfo);
                }}
                initialValues={operatorInfo}
            >
                {(onSubmit, formValues) => (
                    <div className="addDrone_form_wrapper" >
                        <div className="add_drone_form" style={{ padding: currentHeight < 661 ? "5px 30px" : "10px 30px" }}>
                            <InputField
                                defaultValue={operatorInfo.name}
                                label={"Name"}
                                type={"text"}
                                id={"type"}
                                placeholder={"Please Enter Name"}
                                name={"name"}
                                handleChange={(e) => {
                                    // console.log(e)
                                    setOperatorInfo((prev) => ({ ...prev, name: e }))
                                }}
                                validation={nameValidation}
                                containerStyle={{
                                    width: "100%",
                                    maxWidth: "100%",
                                    minHeight: "80px",
                                }}
                            />
                            <InputField
                                defaultValue={operatorInfo.email}
                                label={"Email"}
                                type={"text"}
                                id={"type"}
                                placeholder={"Please Enter Email"}
                                name={"email"}
                                validation={emailValidation}
                                handleChange={(e) => {
                                    // console.log(e)
                                    setOperatorInfo((prev) => ({ ...prev, email: e }))
                                }}
                                containerStyle={{
                                    width: "100%",
                                    maxWidth: "100%",
                                    minHeight: "80px",
                                }}
                            />
                            {!operator?.id && (
                                <InputField
                                    defaultValue={operatorInfo.password}
                                    label={"Password"}
                                    type={"text"}
                                    id={"type"}
                                    placeholder={"Please Enter Password"}
                                    name={"password"}
                                    handleChange={(e) => {
                                        // console.log(e)
                                        setOperatorInfo((prev) => ({ ...prev, password: e }))
                                    }}
                                    validation={passwordValidation}
                                    containerStyle={{
                                        width: "100%",
                                        maxWidth: "100%",
                                        minHeight: "80px",
                                    }}
                                />
                            )}
                            <div>

                                <div>
                                    <SelectField
                                        handleChange={(selectedOption) => {
                                            setOperatorInfo((prevState) => ({
                                                ...prevState,
                                                bhumeet_role: selectedOption
                                            }));

                                        }}
                                        name={"bhumeet_role"}
                                        label={"Role"}
                                        list={teamRolesOptions}
                                        styles={{ width: "215px", height: "18px", fontSize: "13px", margin: "0 0 0 -1px" }}
                                        validation={selectFieldValidation}
                                        placeholderText={"Select role"}
                                        defaultValue={operator?.id ? { label: operatorInfo?.bhumeet_role, value: operatorInfo?.bhumeet_role } : null}
                                        containerStyle={{
                                            width: "100%",
                                            maxWidth: "100%",
                                            minHeight: "80px",
                                        }}
                                    />

                                </div>


                                
                                <div>

                                {(operator && operatorInfo.bhumeet_role.label == 'Telecaller') &&
                                <div style={{ fontSize: '14px', display: "flex", flexDirection: "column", rowGap: "8px", overflowY: "auto", height: "100%", color: "#3B3B3B", fontWeight: 500, maxHeight: "200px" }}>


                                    <div style={{ fontSize: "16px", fontWeight: 500 }}>Assign status :</div>

                                    {teleSubvalue?.map(dsp =>
                                        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                            <div style={{ width: "25px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                <input
                                                    // disabled={isHideDSPFilter}
                                                    checked={operatorInfo?.assignStatus?.filter(assign => assign === dsp).length > 0}
                                                    onChange={handleOnChangeAssignee}
                                                    value={dsp}
                                                    type={"checkbox"}
                                                    className="input-checkbox"
                                                    style={{ width: "16px" }}
                                                />
                                            </div>
                                            <Tippy content={dsp}>
                                                <span style={{ lineHeight: 1.1, fontSize: "15px", fontWeight: 500 }}>{dsp}</span>
                                            </Tippy>
                                        </div>)}
                                </div>
                            }

                                        

                                    </div>
                            </div>

                            


                            <div>

                                {(operatorInfo.bhumeet_role.label == 'Telecaller Sales' || operatorInfo.bhumeet_role.label == 'Telecaller') &&
                                    <div>

                                        <InputField
                                            defaultValue={operatorInfo.MobileNumber}
                                            label={"Mobile Number"}
                                            type={"number"}
                                            id={"type"}
                                            placeholder={"Please Enter Number"}
                                            name={"MobileNumber"}
                                            handleChange={(e) => {
                                                // console.log(e)
                                                setOperatorInfo((prev) => ({ ...prev, MobileNumber: e }))
                                            }}
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: 'Required',
                                                },
                                                pattern: {
                                                    value: /^(\+\d{1,3}[- ]?)?\d{10}$/,
                                                    message: "Required 10 digit"
                                                }
                                            }
                                            }
                                            containerStyle={{
                                                width: "100%",
                                                maxWidth: "100%",
                                                minHeight: "80px",
                                            }}
                                        />

                                        

                                    </div>
                                    
                                }
                                
                                {operatorInfo.bhumeet_role.label == 'Telecaller' &&
                                    
                                    <div>

                                        <MultiSelectField
                                            // checked={true}
                                            className={"multi-select"}
                                            name={"State"}
                                            defaultValue={operatorInfo.State}
                                            placeholderText={"Select State"}
                                            label={"State"}
                                            list={INDIAN_STATES.map(state => { return { label: state, value: state } })}
                                            value={operatorInfo.State}
                                            isSearchable={true}
                                            validation={selectFieldValidation}
                                            controlStyle={{ height: "100%", width: "100%" }}
                                            handleChange={(selectedOption) => {
                                                console.log(selectedOption)
                                                setOperatorInfo((prevState) => ({
                                                    ...prevState,
                                                    State: selectedOption
                                                }));
                                            }}



                                        />



                                    </div>
                                }


                            </div>

                            
                            {(!operator && operatorInfo.bhumeet_role.label == 'Telecaller') &&
                                <div style={{ fontSize: '14px', display: "flex", flexDirection: "column", rowGap: "8px", overflowY: "auto", height: "100%", color: "#3B3B3B", fontWeight: 500, maxHeight: "200px" }}>


                                    <div style={{ fontSize: "16px", fontWeight: 500 }}>Assign status :</div>

                                    {teleSubvalue?.map(dsp =>
                                        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                            <div style={{ width: "25px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                <input
                                                    // disabled={isHideDSPFilter}
                                                    checked={operatorInfo?.assignStatus?.filter(assign => assign === dsp).length > 0}
                                                    onChange={handleOnChangeAssignee}
                                                    value={dsp}
                                                    type={"checkbox"}
                                                    className="input-checkbox"
                                                    style={{ width: "16px" }}
                                                />
                                            </div>
                                            <Tippy content={dsp}>
                                                <span style={{ lineHeight: 1.1, fontSize: "15px", fontWeight: 500 }}>{dsp}</span>
                                            </Tippy>
                                        </div>)}
                                </div>
                            }





                        </div>
                        <hr style={{ marginBottom: "10px" }} />
                        {operatorInfo.bhumeet_role.label == 'Telecaller' &&
                            <div style={{ marginTop: "-10px", display: "flex", marginLeft: "28px", width: "350px" }}>

                                <MultiSelectField
                                    // checked={true}
                                    className={"multi-select"}
                                    name={"Dsp"}
                                    defaultValue={operatorInfo.Dsp}
                                    placeholderText={"Select DSP To Exclude Queue"}
                                    label={"DSP"}
                                    list={dsplist}
                                    value={operatorInfo.Dsp}
                                    isSearchable={true}
                                    // validation={selectFieldValidation}
                                    controlStyle={{ height: "100%", width: "250px" }}
                                    handleChange={(selectedOption) => {
                                        // console.log(selectedOption)
                                        setOperatorInfo((prevState) => ({
                                            ...prevState,
                                            Dsp: selectedOption
                                        }));
                                    }}



                                />
                            </div>
                        }

                        {(operatorInfo.Dsp?.length > 0 && operatorInfo.assignStatus.length > 0 && operatorInfo.bhumeet_role.label == 'Telecaller') &&
                            <>

                                <label style={{ marginLeft: "26px", fontSize: "16px", fontWeight: "600" }}>Calls to Exclude for Specific DSP</label>

                                <div style={{ display: "flex", flexWrap: "wrap", width: "100%", justifyContent: "space-between", marginLeft: "24px", marginTop: "10px", marginBottom: "20px" }}>

                                    {operatorInfo.Dsp.map(dsps => {
                                        return <div style={{ width: "33.33%", marginBottom: "10px" }}>
                                            <h1>{dsps.label}</h1>
                                            {operatorInfo.assignStatus?.map(dsp =>
                                                <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                                    <div style={{ width: "25px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                        <input
                                                            // disabled={isHideDSPFilter}
                                                            checked={operator ? operatorInfo?.Dsp?.some(assign => assign.label === dsps.label && operator ? assign?.excludeStatus?.includes(dsp) : null) : null}

                                                            onChange={(e) => handleOnChangeDsp(e, dsps.label)}
                                                            value={dsp}
                                                            type={"checkbox"}
                                                            className="input-checkbox"
                                                            style={{ width: "16px" }}
                                                        />
                                                    </div>
                                                    <Tippy content={dsp}>
                                                        <span style={{ lineHeight: 1.1, fontSize: "15px", fontWeight: 500 }}>{dsp}</span>
                                                    </Tippy>
                                                </div>)}
                                        </div>
                                    })}
                                </div>

                            </>

                        }


                        <div
                            className="buttons_wrapper"
                            style={{ padding: currentHeight < 661 ? "5px 30px" : "10px 30px" }}
                        >
                            <Button
                                className={"btn-large"}
                                text={operator?.id ? "Update" : "Add"}
                                onClick={onSubmit}
                                style={{ width: "100px" }}
                            />
                            <Button
                                className={"btn-large lg-cancel-btn "}
                                text={"Cancel"}
                                onClick={onClose}
                                isBtnNotActive={true}
                            />
                        </div>
                    </div>
                )}
            </Form>
        </Modal>
    )
}
